export const fileTypes = {
  image: "image",
  video: "video",
  media: "media",
  csv: "csv",
  bin: "bin",
  zip: "zip"
};

const _fileTypeConfigs = {
  [fileTypes.image]: {
    accept: ".jpg, .jpeg, .png, .gif, .webp",
    extensions: ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/webp"]
  },

  [fileTypes.video]: {
    accept: ".mp4, .mov, .wmv, .avi, .mkv, .webm",
    extensions: ["video/mp4", "video/mov", "video/wmv", "video/avi", "video/mkv", "video/webm"]
  },

  [fileTypes.csv]: {
    accept: ".csv",
    extensions: ["text/csv"]
  },

  [fileTypes.bin]: {
    accept: ".bin",
    extensions: ["application/octet-stream", "application/macbinary"]
  },

  [fileTypes.zip]: {
    accept: ".zip",
    extensions: ["application/zip"]
  }
};

_fileTypeConfigs[fileTypes.media] = {
  accept: `${_fileTypeConfigs[fileTypes.image].accept}, ${
    _fileTypeConfigs[fileTypes.video].accept
  }`,
  extensions: [
    ..._fileTypeConfigs[fileTypes.image].extensions,
    ..._fileTypeConfigs[fileTypes.video].extensions
  ]
};

export const fileTypeConfigs = _fileTypeConfigs;
